
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.3 12.36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f8bf13","d":"M7.62 10.26s-.46 1.55-.96 1.55c-.32 0-.79.22-1.1.45-.17.13-.41.13-.57 0-.3-.23-.78-.45-1.1-.45-.5 0-.84-1.28-.84-1.28l2.22-.16 2.34-.11z"}}),_c('path',{attrs:{"fill":"#ce952e","d":"M8.9 10.03c-.39.39-1.49 1.27-3.62 1.38h-.42c-2.13-.1-3.23-.98-3.62-1.38-.32-.32 0-1 0-1l3.83 1.13L8.9 9.03s.32.67 0 1z"}}),_c('path',{attrs:{"fill":"#f8bf13","d":"M5.28 11.41c-.07.01-.14.01-.21 0h.21zm-.21.01h-.21.21z"}}),_c('path',{attrs:{"fill":"#fff","d":"M5.28.13C2.5.13.25 2.38.25 5.16s2.25 5.02 5.03 5.02 5.02-2.25 5.02-5.02S8.05.13 5.28.13zm0 8.51c-.35 0-.62-1.56-.62-3.48s.27-3.49.62-3.49.61 1.56.61 3.49-.27 3.48-.61 3.48z"}}),_c('path',{attrs:{"fill":"#f8bf13","d":"M9.71 7.51c0 .84-.97 3.33-4.54 3.33-1.76 0-2.98-.52-3.79-1.27C.14 8.4-.24 6.76.14 5.11c.05-.22.1-.37.11-.4C.25 1.88 3.03 0 5.19 0s3.17 1.18 3.17 1.18C7.87.92 7.48.82 6.73.71 5.98.6 6.05.94 5.08.94 2.6.94 1.74 2.46 1.74 2.46c-.4.34-.73 1.04-.77 1.13 1.5-2.03 3.42-1.6 3.42-1.6-2.53.78-2.92 3.02-2.92 3.02C.8 5.57.58 6.26.56 6.35c.64-1.49 1.93-1.66 1.93-1.66-1.07 1.29-1.29 4.8 2.94 4.8s3.08-4.36 3.08-4.36c.41.22 1.2 1.51 1.2 2.36z"}}),_c('path',{attrs:{"fill":"#ce952e","d":"M8.36 1.18C7.87.92 7.48.82 6.73.71 5.98.6 6.05.94 5.08.94 2.6.94 1.74 2.46 1.74 2.46c-.4.34-.73 1.04-.77 1.13 0 0-.47.51-.72 1.1C.25 1.88 3.03 0 5.19 0s3.17 1.18 3.17 1.18z"}})])
          )
        }
      }
    